import { render, staticRenderFns } from "./dialogue-with-buttons.vue?vue&type=template&id=ebc1e334&"
import script from "./dialogue-with-buttons.vue?vue&type=script&lang=js&"
export * from "./dialogue-with-buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports